import { useEffect } from 'react';

const Matomo = () => {
  useEffect(() => {
    window._paq = window._paq || [];
    window._paq.push(['trackPageView']);
    window._paq.push(['enableLinkTracking']);
    (function () {
      const u = 'https://analytics.x-net.at/';
      window._paq.push(['setTrackerUrl', u + 'matomo.php']);
      window._paq.push(['setSiteId', '40']);
      const d = document;
      const g = d.createElement('script');
      const s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = u + 'matomo.js';
      s.parentNode.insertBefore(g, s);
    })();
  }, []);

  return null; // This component doesn't render any visible UI
};

export default Matomo;
